import axios from "../../../../utils/AxiosUtils";
import i18n from "../../../../i18next";
import { LOADING, LOAD_DAYS_OFF_SUCCESS, UPDATE_DAYS_OFF_SUCCESS, RESET_DAYS_OFF } from "../../../types";
import MessageUtils from "../../../../utils/MessageUtils";

export const loadDaysOff = (restaurantId) => {
    return (dispatch) => {
        
        if (Number(restaurantId) !== -1) {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/days-off`;

            axios().get(url)
                .then(response => loadDaysOffSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:daysOffActions.loadDaysOffFailure')));
        }
    }
};

export const updateDaysOff = (daysOff, restaurantId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/days-off`;

        axios().post(url, daysOff)
            .then(response => updateDaysOffSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:daysOffActions.updateDaysOffFailure')));
    }
};

const loadDaysOffSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_DAYS_OFF_SUCCESS, payload: response.data });
};

const updateDaysOffSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_DAYS_OFF_SUCCESS, payload: response.data });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:daysOffActions.saveDaysOffSuccessMessage'));
};

export const resetDaysOff = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: RESET_DAYS_OFF });
    }
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/restaurant/DaysOffActions.js